import React, {useEffect, useState} from 'react';
import './VerifyEmailCard.scss';
import {MailCheck, RefreshCw} from 'lucide-react';
import {toast} from "react-toastify";
import Button from "../../ui/Button/Button";
import {useProfileStore} from "../../../store/profile/pofile.store";
import {sendVerificationEmail} from "../../../services/firebase_services";
import {checkEmailVerified} from "../../../services/verification";

const RESEND_COOLDOWN_SECONDS = 60;

// Firebase limits how often verification emails can be sent
const resendErrorMessage = (err: any) => {
    if (err?.code === 'auth/too-many-requests') return 'Too many emails sent. Please wait a few minutes and try again.';
    if (err?.message === 'NOT_SIGNED_IN') return 'Please sign out and sign in again, then resend the email.';
    return 'Could not send the email. Please try again.';
};

const VerifyEmailCard = () => {
    const {user, updateUser}: any = useProfileStore();
    const [cooldown, setCooldown] = useState(0);
    const [checking, setChecking] = useState(false);

    useEffect(() => {
        if (!cooldown) return;
        const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
        return () => clearTimeout(timer);
    }, [cooldown]);

    const resend = async () => {
        try {
            await sendVerificationEmail();
            toast.success(`Verification email sent to ${user?.email}`);
            setCooldown(RESEND_COOLDOWN_SECONDS);
        } catch (err) {
            toast.error(resendErrorMessage(err));
        }
    };

    const checkNow = async () => {
        setChecking(true);
        try {
            const verified = await checkEmailVerified(updateUser);
            if (verified) {
                toast.success('Email verified, thank you!');
            } else {
                toast.info("Not verified yet. Click the link in the email, then try again.");
            }
        } catch (err) {
            toast.error('Could not check right now. Please try again.');
        } finally {
            setChecking(false);
        }
    };

    return (
        <div className="card VerifyEmailCard">
            <div className="icon-tile icon-tile--gradient VerifyEmailCard__icon"><MailCheck size={26}/></div>
            <h3>Verify your email to create a chat</h3>
            <p>
                We sent a link to <b>{user?.email}</b>. Click it, then come back here. Can't find it? Check your spam
                folder.
            </p>
            <div className="VerifyEmailCard__buttons">
                <Button type={'button'} variant={'secondary'} onClick={resend} disabled={cooldown > 0}
                        title={cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend email'}/>
                <Button type={'button'} variant={'primary'} onClick={checkNow} disabled={checking}
                        title={checking ? 'Checking...' : "I've verified"} icon={<RefreshCw size={16}/>}/>
            </div>
        </div>
    );
};

export default VerifyEmailCard;
